import React from 'react'
import { Button } from 'reactstrap'

export default function DeleteAssignment (props) {
  return (
    <Button
      color='danger'
      onClick={() => props.deleteAssignment()}
      disabled={props.assignmentId ? false : true}
    >
      Delete Assignment
    </Button>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assignments/AssignmentsManage/DeleteAssignment.js